import React from "react";
import FlashcardApp from "./FlashcardApp";

function App() {
  return (
    <div>
      <h1 style={{textAlign: "center", marginTop: "32px"}}>Water Distribution Flashcards</h1>
      <FlashcardApp />
    </div>
  );
}

export default App;
